import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
	header: {
		paddingLeft: theme.spacing(1)
	},
	chartGrid: {
		margin: '0px !important',
		width: '100%'
		// Transform: 'translateZ(0)',
	},
	gridListTile: {
		overflowX: 'hidden'
	},
	noteContainer: {
		marginTop: theme.spacing(5),
		marginLeft: theme.spacing(1)
	}
}));
